module.exports = __webpack_public_path__ + "img/ywAward-2.ff7e101b.png";